import $ from 'jquery';
import * as d3 from 'd3';
import * as React from 'react';
import { observer } from 'mobx-react';
import { IRectangleWithGradientProps } from './IRectangleWithGradientProps';

@observer
export class RectangleWithGradient extends React.Component<IRectangleWithGradientProps> {
  constructor(props: IRectangleWithGradientProps) {
    super(props, undefined);
  }

  componentDidMount(): void {
    if (RectangleWithGradient.isBackgroundLoading) return;

    setTimeout(() => this.loadRectangle());
  }

  componentDidUpdate() {
    if (RectangleWithGradient.isBackgroundLoading) return;

    this.loadRectangle();
  }

  loadRectangle() {
    if (RectangleWithGradient.isBackgroundLoading) {
      setTimeout(() => this.loadRectangle());
      return;
    }

    if (RectangleWithGradient.backgroundSvg) {
      setTimeout(() => this.setBackground(RectangleWithGradient.backgroundSvg));
      return;
    }

    RectangleWithGradient.isBackgroundLoading = true;
    d3.xml('Images/rectangleWithGradient.svg', d => {
      RectangleWithGradient.isBackgroundLoading = false;
      RectangleWithGradient.backgroundSvg = $(d.documentElement).children();
      this.setBackground(RectangleWithGradient.backgroundSvg);
    });
  }

  private setBackground(backgroundSvg: any): void {
    $('.rectangle-wrapper').empty();
    $('.rectangle-wrapper').append(backgroundSvg);
  }
  private static isBackgroundLoading: boolean = false;
  private static backgroundSvg: any = null;

  render() {
    var pointsTransform = 'translate(' + this.props.x + ',' + this.props.y + ')';
    return (
      <g className="rectangle-wrapper" transform={pointsTransform}>
        {}
      </g>
    );
  }
}
